import { EntityTransactionMonitoringComponent } from './entities/transaction-monitoring/entity-transaction-monitoring.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AuthenticationGuard } from 'app/services/authentication-guard.service';
import { CanDeactivateGuard } from 'app/services/can-deactivate.service';

import { DashboardComponent } from 'app/dashboard/dashboard.component';
import { DnbdashboardComponent } from './dnbdashboard/dnbdashboard.component';
import { EntityDossierComponent } from 'app/entities/entity-dossier.component';
import { EntityDetailsComponent } from 'app/entities/details/entity-details.component';
import { EntityDocumentsComponent } from 'app/entities/documents/entity-documents.component';
import { EntityAuditComponent } from 'app/entities/audit/entity-audit.component';
import { EntityRelationsComponent } from 'app/entities/relations/entity-relations.component';
import { EntityEmailsComponent } from 'app/entities/emails/emails.component';
import { EntityFinanceComponent } from 'app/entities/finance/entity-finance.component';
import { EntityMonitoringComponent } from 'app/entities/monitoring/entity-monitoring.component';
import { EntitySurveysComponent } from 'app/entities/surveys/entity-surveys.component';
import { EntityTimeTrackingComponent } from 'app/entities/time-tracking/entity-time-tracking.component';
import { EntityTransactionProfileComponent } from 'app/entities/transaction-profile/entity-transaction-profile.component';
import { EntityOtherComponent } from 'app/entities/other/entity-other.component';

import { ContentComponent } from 'app/clients/client/content/content.component';
import { ClientsOverviewComponent } from 'app/clients/overview/clients-overview.component';
import { ClientReviewComponent } from 'app/clients/reviews/client-review.component';
import { BankInstitutionsComponent } from 'app/finance/bankinstitutions/bankinstitutions.component';
import { PaymentsComponent } from 'app/finance/payments/payments.component';
import { BankStatementsBatchComponent } from 'app/finance/bank-statements-batch/bank-statements-batch.component';
import { PendingTransactionsOverviewComponent } from 'app/finance/pending-transactions-overview/pending-transactions-overview.component';
import { PendingHitsOverviewComponent } from 'app/entities/monitoring/pending-hits-overview/pending-hits-overview.component';
import { AlertsInboxComponent } from 'app/alerts/alerts-inbox.component';
import { TenantConfigurationComponent } from 'app/admin/tenantconfiguration/tenant-configuration.component';

import { UsersComponent } from 'app/admin/users/users.component';
import { UserPreferencesComponent } from 'app/header/usersettings/userpreferences/user-preferences.component';
import { GroupComponent } from 'app/admin/groups/group.component';
import { ArchivalComponent } from 'app/admin/archival/archival.component';
import { IntegrationsComponent } from 'app/admin/integrations/integrations.component';
import { ProcessComponent } from 'app/admin/processes/process.component';
import { SurveyComponent } from 'app/admin/survey/survey.component';
import { SanctionlogsComponent } from 'app/reports/sanctionlogs/sanctionlogs.component';
import { RuleComponent } from 'app/admin/rules/rule.component';
import { ApplicationActivityComponent } from 'app/admin/applicationactivity/application-activity.component';
import { ServiceComponent } from 'app/admin/services/service.component';
import { ImportClientComponent } from 'app/admin/importclient/import-client.component';
import { WorkflowComponent} from './workflow/workflow/workflow.component';
import { EntityNewCafComponent } from './entity-new-caf/entity-new-caf.component';
import { IsiReportDetailTwoComponent } from './reports/isi-report-detail-two/isi-report-detail-two.component';
import { IsiReportDetailSubofficesComponent } from './reports/isi-report-detail-suboffices/isi-report-detail-suboffices.component';
import {ImportComponent} from './admin/import/import.component';
import { TransactionProfileExportComponent } from './admin/transaction-profile-export/transaction-profile-export.component';

const appRoutes: Routes = [
    { path: '', redirectTo: 'dashboard', canActivate: [AuthenticationGuard], pathMatch: 'full' },
    {
      path: 'dnbdashboard',
      canActivate: [AuthenticationGuard],
      canDeactivate: [CanDeactivateGuard],
      component: DnbdashboardComponent
    },
    {
        path: 'dashboard',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: DashboardComponent
    },
    {
        path: 'sanctionlogs',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: SanctionlogsComponent
    },
    {
        path: 'isireport/:officeId/:year',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: IsiReportDetailSubofficesComponent
    },
    {
      path: 'newreport/:year',
      canActivate: [AuthenticationGuard],
      canDeactivate: [CanDeactivateGuard],
      component: IsiReportDetailTwoComponent
    },
    {
        path: 'clients',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: ClientsOverviewComponent
    },
    {
        path: 'reviews',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: ClientReviewComponent
    },
    {
        path: 'bankinstitutions',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: BankInstitutionsComponent
    },
    {
        path: 'bank-statements-batch',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: BankStatementsBatchComponent
    },
    {
        path: 'pending-transactions-overview',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: PendingTransactionsOverviewComponent
    },
    {
        path: 'pending-hits-overview',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: PendingHitsOverviewComponent
    },
    {
        path: 'alerts',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: AlertsInboxComponent
    },
    {
        path: 'payments',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: PaymentsComponent
    },
    {
      path: 'workflow',
      canActivate: [AuthenticationGuard],
      canDeactivate: [CanDeactivateGuard],
      component: WorkflowComponent,
    },
    {
        path: 'users',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: UsersComponent
    },
    {
        path: 'userPreferences',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: UserPreferencesComponent
    },
    {
        path: 'groups',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: GroupComponent
    },
    {
        path: 'archivals',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: ArchivalComponent
    },
    {
        path: 'integrations',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: IntegrationsComponent
    },
    {
        path: 'processes',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: ProcessComponent
    },
    {
        path: 'surveys',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: SurveyComponent
    },
    {
        path: 'tenantconfiguration',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: TenantConfigurationComponent
    },
    {
      path: 'imports',
      canActivate: [AuthenticationGuard],
      canDeactivate: [CanDeactivateGuard],
      component: ImportComponent
    },
    {
      path: 'transaction-profiles-export',
      canActivate: [AuthenticationGuard],
      canDeactivate: [CanDeactivateGuard],
      component: TransactionProfileExportComponent
    },
    {
        path: 'services',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: ServiceComponent
    },
    {
        path: 'rules',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: RuleComponent
    },
    {
        path: 'appactivity',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: ApplicationActivityComponent
    },
    {
        path: 'importclient',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: ImportClientComponent
    },
    {
        path: 'entity/:entityId',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: EntityDossierComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'details'
            },
            {
                path: 'details',
                component: EntityDetailsComponent
            },
            {
                path: 'documents',
                component: EntityDocumentsComponent
            },
            {
                path: 'audits',
                component: EntityAuditComponent
            },
            {
                path: 'caf',
                redirectTo: 'newCaf'
            },
            {
              path: 'newCaf',
              component: EntityNewCafComponent
            },
            {
                path: 'relations',
                component: EntityRelationsComponent
            },
            {
                path: 'emails',
                component: EntityEmailsComponent
            },
            {
                path: 'finance',
                component: EntityFinanceComponent
            },
            {
                path: 'time-tracking',
                component: EntityTimeTrackingComponent
            },
            {
                path: 'transaction-profile',
                component: EntityTransactionProfileComponent
            },
            {
                path: 'transaction-monitoring',
                component: EntityTransactionMonitoringComponent
            },
            {
                path: 'monitoring',
                component: EntityMonitoringComponent
            },
            {
                path: 'surveys',
                component: EntitySurveysComponent
            },
            {
                path: 'other',
                component: EntityOtherComponent
            },
            {
                path: 'compliance',
                component: WorkflowComponent
            }
        ]
    },
    {
        path: 'entity/:type/:id',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: EntityDossierComponent,
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'details'
            },
            {
                path: 'details',
                component: EntityDetailsComponent
            },
            {
                path: 'documents',
                component: EntityDocumentsComponent
            },
            {
                path: 'audits',
                component: EntityAuditComponent
            },
            {
                path: 'caf',
                redirectTo: 'newCaf'
            },
            {
              path: 'newCaf',
              component: EntityNewCafComponent
            },
            {
                path: 'relations',
                component: EntityRelationsComponent
            },
            {
                path: 'emails',
                component: EntityEmailsComponent
            },
            {
                path: 'finance',
                component: EntityFinanceComponent
            },
            {
                path: 'time-tracking',
                component: EntityTimeTrackingComponent
            },
            {
                path: 'transaction-profile',
                component: EntityTransactionProfileComponent
            },
            {
                path: 'transaction-monitoring',
                component: EntityTransactionMonitoringComponent
            },
            {
                path: 'monitoring',
                component: EntityMonitoringComponent
            },
            {
                path: 'surveys',
                component: EntitySurveysComponent
            },
            {
                path: 'other',
                component: EntityOtherComponent
            },
            {
                path: 'compliance',
                component: WorkflowComponent
            }
        ]
    },
    // @todo can eventually be removed.
    {
        path: 'appContent',
        canActivate: [AuthenticationGuard],
        canDeactivate: [CanDeactivateGuard],
        component: ContentComponent

    },
];
@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes)
    ],
    exports: [
        RouterModule
    ]
})

/**
 * Main Routing module for the application.
 */
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts